import Swiper, {Navigation, Pagination, Lazy} from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);

const initCoachesSlider = () => {
  const sliderContainer = document.querySelector("[data-coaches-slider]");
  sliderContainer && new Swiper(sliderContainer, {
    lazy: true,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },       
      0: {
        slidesPerView: 1.7,
      },
    },
    pagination: {
      el: "[data-coaches-slider] .swiper-pagination",
      clickable: true,
      bulletElement: "button",
      dynamicBullets: true,
      dynamicMainBullets: 5,
    },
    navigation: {
      nextEl: "[data-coaches-slider] .slider-navigation__button--next",
      prevEl: "[data-coaches-slider] .slider-navigation__button--prev",
    },
  });  
};

export default initCoachesSlider;
